module.exports = __webpack_public_path__ + "static/media/gwp_60yd_y-1.a724d17c.csv";